import { Button, Card, CardActions, CardContent, Grid, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import nl2br from 'react-nl2br'

const useStyles = makeStyles((theme) => ({
    cardActions: {
        display: 'flex',
        justifyContent: 'space-between',
    },
}))

export default function StoreCard(props) {
    const { store } = props
    const classes = useStyles()

    function handleStoreSelect() {
        props.onStoreSelect(store, true)
    }

    return (
        <Grid item xs={12} sm={6} md={6}>
            <Card>
                <CardContent>
                    <Typography gutterBottom variant="h5">
                        {store.name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        {nl2br(store.address)}
                    </Typography>
                </CardContent>
                <CardActions>
                    <Button size="small" color="primary" onClick={handleStoreSelect}>
                        Choose This Location
                    </Button>
                </CardActions>
            </Card>
        </Grid>
    )
}
